import { buildSchemaConfigTaskGroupsAPI } from "@/services/api.services";

import { SavedObject } from "../commonModels";

export type TaskGroup = {
    day: number | null;
    name: string;
    date: string | null;
    experimentCode: string | null;
    protocolCode: string | null;
    schemaConfigId: string | null;
    readoutGroupIds: string[] | null;
    taskReferenceId: string | null;
    referencedThingId: string | null;
    dayAfterReference: number | null;
    taskThingDateEstimateId: string | null;
};

export type SavedTaskGroup = TaskGroup & SavedObject<string>;

export const taskGroupsAPI = {
    bySchemaConfig: (schemaConfigId: string) => {
        return buildSchemaConfigTaskGroupsAPI(schemaConfigId);
    },
};
